export const LabelsData = {
  publisher_id: {
    value: 1,
    key: 'publisher_id',
    label: 'Order number'
  },
  publisher_customer_id: {
    value: 2,
    key: 'publisher_customer_id',
    label: 'Account number'
  },
  reference_id: {
    value: 3,
    key: 'reference_id',
    label: 'Notice name'
  }
};
